import styled from 'styled-components';

import biedron from './biedronka.jpg';

const MainAboutDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoHolder = styled.div`
  display: flex;
  width: 100%;
  height: 680px;
  justify-content: center;
`;

const BierdonkaImg = styled.img`
  width: 100%;
  height: auto;
  display: flex;
`;

export const About = (params) => {
  return (
    <MainAboutDiv>
        <h1 style={{color: '#85be80'}}>Z nami Edukacja to też zabawa :)</h1>
      <LogoHolder>
        <BierdonkaImg src={biedron} alt="Bierdonka"></BierdonkaImg>
      </LogoHolder>
      <p>Żłobek dla dzieci Biedroneczki jest idealnym miejscem dla rodziców którzy chcą oddać swe pociechy w odpowiedzialne ręce.<br></br>
      Dzieci mają szanse rozwoju poprzez zabawe co zapewnia największą skuteczność uczenia.</p>
      <p>Zapraszamy do sprawdzenia naszej oferty w zakładce <span style={{fontWeight: 'bold'}}>Oferta</span>.</p>
    </MainAboutDiv>
  );
};
